export interface LayoutElement {
  id: string;
  type: 'wall' | 'door' | 'window' | 'furniture' | 'room';
  x: number;
  y: number;
  width: number;
  height: number;
  label?: string;
  color?: string;
}

export interface FloorPlan {
  id: string;
  name: string;
  type: 'home' | 'restaurant' | 'office' | 'hotel';
  width: number;
  height: number;
  elements: LayoutElement[];
}

export const floorPlans: FloorPlan[] = [
  {
    id: 'home-layout-1',
    name: 'Modern 3-Bedroom Home',
    type: 'home',
    width: 20,
    height: 15,
    elements: [
      // Exterior walls
      { id: 'wall-1', type: 'wall', x: 0, y: 0, width: 20, height: 0.3, color: '#8B4513' },
      { id: 'wall-2', type: 'wall', x: 0, y: 0, width: 0.3, height: 15, color: '#8B4513' },
      { id: 'wall-3', type: 'wall', x: 19.7, y: 0, width: 0.3, height: 15, color: '#8B4513' },
      { id: 'wall-4', type: 'wall', x: 0, y: 14.7, width: 20, height: 0.3, color: '#8B4513' },
      
      // Interior walls
      { id: 'wall-5', type: 'wall', x: 8, y: 0, width: 0.3, height: 8, color: '#A0522D' },
      { id: 'wall-6', type: 'wall', x: 8, y: 10, width: 0.3, height: 5, color: '#A0522D' },
      { id: 'wall-7', type: 'wall', x: 0, y: 8, width: 8, height: 0.3, color: '#A0522D' },
      { id: 'wall-8', type: 'wall', x: 12, y: 8, width: 8, height: 0.3, color: '#A0522D' },
      { id: 'wall-9', type: 'wall', x: 0, y: 12, width: 8, height: 0.3, color: '#A0522D' },
      
      // Doors
      { id: 'door-1', type: 'door', x: 8.1, y: 7.5, width: 0.8, height: 1.5, label: 'Front Door', color: '#8B4513' },
      { id: 'door-2', type: 'door', x: 7.5, y: 7.8, width: 1.5, height: 0.8, label: 'Kitchen', color: '#8B4513' },
      { id: 'door-3', type: 'door', x: 7.5, y: 11.8, width: 1.5, height: 0.8, label: 'Bedroom 1', color: '#8B4513' },
      { id: 'door-4', type: 'door', x: 15.5, y: 7.8, width: 1.5, height: 0.8, label: 'Bedroom 2', color: '#8B4513' },
      { id: 'door-5', type: 'door', x: 15.5, y: 11.8, width: 1.5, height: 0.8, label: 'Bedroom 3', color: '#8B4513' },
      
      // Windows
      { id: 'window-1', type: 'window', x: 2, y: 0.1, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      { id: 'window-2', type: 'window', x: 16, y: 0.1, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      { id: 'window-3', type: 'window', x: 2, y: 14.8, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      { id: 'window-4', type: 'window', x: 16, y: 14.8, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      
      // Furniture - Living Room
      { id: 'furniture-1', type: 'furniture', x: 1, y: 1, width: 3, height: 2, label: 'Sofa', color: '#DEB887' },
      { id: 'furniture-2', type: 'furniture', x: 1, y: 4, width: 2, height: 1, label: 'TV Stand', color: '#DEB887' },
      
      // Furniture - Kitchen Area
      { id: 'furniture-3', type: 'furniture', x: 9, y: 1, width: 1.5, height: 1.5, label: 'Dining Table', color: '#DEB887' },
      { id: 'furniture-4', type: 'furniture', x: 9, y: 3, width: 6, height: 3, label: 'Kitchen Counter', color: '#DEB887' },
      { id: 'furniture-5', type: 'furniture', x: 10, y: 3.5, width: 1, height: 1, label: 'Stove', color: '#696969' },
      { id: 'furniture-6', type: 'furniture', x: 12, y: 3.5, width: 1, height: 1, label: 'Sink', color: '#696969' },
      { id: 'furniture-7', type: 'furniture', x: 14, y: 3.5, width: 1, height: 1, label: 'Fridge', color: '#696969' },
      
      // Furniture - Bedrooms
      { id: 'furniture-8', type: 'furniture', x: 1, y: 9, width: 2, height: 2, label: 'Bed', color: '#DEB887' },
      { id: 'furniture-9', type: 'furniture', x: 13, y: 9, width: 2, height: 2, label: 'Bed', color: '#DEB887' },
      { id: 'furniture-10', type: 'furniture', x: 13, y: 12, width: 2, height: 2, label: 'Bed', color: '#DEB887' },
      
      // Room labels
      { id: 'room-1', type: 'room', x: 1, y: 1, width: 6, height: 6, label: 'Living Room', color: '#F5F5DC' },
      { id: 'room-2', type: 'room', x: 9, y: 1, width: 6, height: 6, label: 'Kitchen', color: '#F5F5DC' },
      { id: 'room-3', type: 'room', x: 1, y: 9, width: 6, height: 5, label: 'Bedroom 1', color: '#F5F5DC' },
      { id: 'room-4', type: 'room', x: 9, y: 9, width: 6, height: 5, label: 'Bedroom 2', color: '#F5F5DC' },
      { id: 'room-5', type: 'room', x: 9, y: 12, width: 6, height: 3, label: 'Bedroom 3', color: '#F5F5DC' }
    ]
  },
  {
    id: 'restaurant-layout-1',
    name: 'Chinese Restaurant',
    type: 'restaurant',
    width: 25,
    height: 18,
    elements: [
      // Exterior walls
      { id: 'wall-1', type: 'wall', x: 0, y: 0, width: 25, height: 0.3, color: '#8B4513' },
      { id: 'wall-2', type: 'wall', x: 0, y: 0, width: 0.3, height: 18, color: '#8B4513' },
      { id: 'wall-3', type: 'wall', x: 24.7, y: 0, width: 0.3, height: 18, color: '#8B4513' },
      { id: 'wall-4', type: 'wall', x: 0, y: 17.7, width: 25, height: 0.3, color: '#8B4513' },
      
      // Interior walls
      { id: 'wall-5', type: 'wall', x: 0, y: 6, width: 8, height: 0.3, color: '#A0522D' },
      { id: 'wall-6', type: 'wall', x: 0, y: 12, width: 8, height: 0.3, color: '#A0522D' },
      { id: 'wall-7', type: 'wall', x: 8, y: 0, width: 0.3, height: 18, color: '#A0522D' },
      { id: 'wall-8', type: 'wall', x: 16, y: 0, width: 0.3, height: 18, color: '#A0522D' },
      
      // Doors
      { id: 'door-1', type: 'door', x: 12, y: 0.1, width: 1, height: 1.5, label: 'Main Entrance', color: '#8B4513' },
      { id: 'door-2', type: 'door', x: 7.5, y: 5.8, width: 1.5, height: 0.8, label: 'Kitchen', color: '#8B4513' },
      { id: 'door-3', type: 'door', x: 7.5, y: 11.8, width: 1.5, height: 0.8, label: 'Storage', color: '#8B4513' },
      { id: 'door-4', type: 'door', x: 15.5, y: 5.8, width: 1.5, height: 0.8, label: 'Office', color: '#8B4513' },
      
      // Windows
      { id: 'window-1', type: 'window', x: 2, y: 0.1, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      { id: 'window-2', type: 'window', x: 6, y: 0.1, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      { id: 'window-3', type: 'window', x: 18, y: 0.1, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      { id: 'window-4', type: 'window', x: 22, y: 0.1, width: 2, height: 0.1, label: 'Window', color: '#87CEEB' },
      
      // Furniture - Tables (smaller, properly spaced)
      { id: 'furniture-1', type: 'furniture', x: 1, y: 1, width: 1.5, height: 1.5, label: 'Table 1', color: '#DEB887' },
      { id: 'furniture-2', type: 'furniture', x: 3, y: 1, width: 1.5, height: 1.5, label: 'Table 2', color: '#DEB887' },
      { id: 'furniture-3', type: 'furniture', x: 1, y: 3, width: 1.5, height: 1.5, label: 'Table 3', color: '#DEB887' },
      { id: 'furniture-4', type: 'furniture', x: 3, y: 3, width: 1.5, height: 1.5, label: 'Table 4', color: '#DEB887' },
      { id: 'furniture-5', type: 'furniture', x: 9, y: 1, width: 1.5, height: 1.5, label: 'Table 5', color: '#DEB887' },
      { id: 'furniture-6', type: 'furniture', x: 11, y: 1, width: 1.5, height: 1.5, label: 'Table 6', color: '#DEB887' },
      { id: 'furniture-7', type: 'furniture', x: 13, y: 1, width: 1.5, height: 1.5, label: 'Table 7', color: '#DEB887' },
      { id: 'furniture-8', type: 'furniture', x: 15, y: 1, width: 1.5, height: 1.5, label: 'Table 8', color: '#DEB887' },
      { id: 'furniture-9', type: 'furniture', x: 17, y: 1, width: 1.5, height: 1.5, label: 'Table 9', color: '#DEB887' },
      { id: 'furniture-10', type: 'furniture', x: 19, y: 1, width: 1.5, height: 1.5, label: 'Table 10', color: '#DEB887' },
      { id: 'furniture-11', type: 'furniture', x: 21, y: 1, width: 1.5, height: 1.5, label: 'Table 11', color: '#DEB887' },
      { id: 'furniture-12', type: 'furniture', x: 9, y: 3, width: 1.5, height: 1.5, label: 'Table 12', color: '#DEB887' },
      { id: 'furniture-13', type: 'furniture', x: 11, y: 3, width: 1.5, height: 1.5, label: 'Table 13', color: '#DEB887' },
      { id: 'furniture-14', type: 'furniture', x: 13, y: 3, width: 1.5, height: 1.5, label: 'Table 14', color: '#DEB887' },
      { id: 'furniture-15', type: 'furniture', x: 15, y: 3, width: 1.5, height: 1.5, label: 'Table 15', color: '#DEB887' },
      { id: 'furniture-16', type: 'furniture', x: 17, y: 3, width: 1.5, height: 1.5, label: 'Table 16', color: '#DEB887' },
      { id: 'furniture-17', type: 'furniture', x: 19, y: 3, width: 1.5, height: 1.5, label: 'Table 17', color: '#DEB887' },
      { id: 'furniture-18', type: 'furniture', x: 21, y: 3, width: 1.5, height: 1.5, label: 'Table 18', color: '#DEB887' },
      
      // Kitchen equipment (larger than tables)
      { id: 'furniture-19', type: 'furniture', x: 1, y: 7, width: 3, height: 2, label: 'Stove', color: '#696969' },
      { id: 'furniture-20', type: 'furniture', x: 4, y: 7, width: 3, height: 2, label: 'Prep Counter', color: '#696969' },
      
      // Storage (larger than tables)
      { id: 'furniture-21', type: 'furniture', x: 1, y: 13, width: 3, height: 2, label: 'Storage Shelves', color: '#696969' },
      { id: 'furniture-22', type: 'furniture', x: 4, y: 13, width: 3, height: 2, label: 'Refrigerator', color: '#696969' },
      
      // Office (larger than tables)
      { id: 'furniture-23', type: 'furniture', x: 17, y: 7, width: 2, height: 2, label: 'Desk', color: '#DEB887' },
      { id: 'furniture-24', type: 'furniture', x: 17, y: 10, width: 2, height: 2, label: 'Filing Cabinet', color: '#DEB887' },
      
      // Room labels
      { id: 'room-1', type: 'room', x: 1, y: 1, width: 6, height: 4, label: 'Dining Area 1', color: '#F5F5DC' },
      { id: 'room-2', type: 'room', x: 9, y: 1, width: 14, height: 4, label: 'Dining Area 2', color: '#F5F5DC' },
      { id: 'room-3', type: 'room', x: 1, y: 7, width: 6, height: 4, label: 'Kitchen', color: '#F5F5DC' },
      { id: 'room-4', type: 'room', x: 1, y: 13, width: 6, height: 4, label: 'Storage', color: '#F5F5DC' },
      { id: 'room-5', type: 'room', x: 9, y: 7, width: 6, height: 10, label: 'Office', color: '#F5F5DC' },
      { id: 'room-6', type: 'room', x: 17, y: 7, width: 6, height: 10, label: 'Private Dining', color: '#F5F5DC' }
    ]
  }
];

export const getLayoutForLocation = (locationName: string): FloorPlan | null => {
  const locationLower = locationName.toLowerCase();
  
  // Check for specific location names first
  if (locationLower.includes('marina bay sands')) {
    return floorPlans.find(plan => plan.type === 'home') || null;
  }
  
  if (locationLower.includes('chinatown restaurant')) {
    return floorPlans.find(plan => plan.type === 'restaurant') || null;
  }
  
  // Check for general keywords
  if (locationLower.includes('home') || locationLower.includes('house') || locationLower.includes('apartment') || locationLower.includes('hotel')) {
    return floorPlans.find(plan => plan.type === 'home') || null;
  }
  
  if (locationLower.includes('restaurant') || locationLower.includes('cafe') || locationLower.includes('dining')) {
    return floorPlans.find(plan => plan.type === 'restaurant') || null;
  }
  
  return null;
};
